import Keycloak from 'keycloak-js';

// Validate required environment variables
const KEYCLOAK_URL = process.env.KEYCLOAK_URL;
const KEYCLOAK_REALM = process.env.KEYCLOAK_REALM;
const KEYCLOAK_CLIENT_ID = process.env.KEYCLOAK_CLIENT_ID;

if (!KEYCLOAK_URL) {
  throw new Error('Missing required environment variable: KEYCLOAK_URL');
}
if (!KEYCLOAK_REALM) {
  throw new Error('Missing required environment variable: KEYCLOAK_REALM');
}
if (!KEYCLOAK_CLIENT_ID) {
  throw new Error('Missing required environment variable: KEYCLOAK_CLIENT_ID');
}

const keycloak = new Keycloak({
  url: KEYCLOAK_URL,
  realm: KEYCLOAK_REALM,
  clientId: KEYCLOAK_CLIENT_ID,
});

export default keycloak;
